import { HStack } from '@pets-ui/HStack/HStack'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type CouponConditionProps } from './CouponCondition'

const styles = stylex.create({
  text: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
})

export interface CouponConditionLabelProps {
  displayName: CouponConditionProps['displayName']
  count?: CouponConditionProps['count']
}

export const CouponConditionLabel = (props: CouponConditionLabelProps) => {
  const { displayName, count } = props
  const shouldShowCountText = Boolean(count && count > 1)

  return (
    <HStack gap={1} alignItems="center" flex={1}>
      {shouldShowCountText && <Text variant="caption" color={colors.green400}>{`x${count}`}</Text>}
      <Text variant="caption" rootStyle={styles.text} color={colors.grey600}>{displayName}</Text>
    </HStack>
  )
}
